import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const proxied = (url) => (url ? `${API}/instagram/image?u=${encodeURIComponent(url)}` : "");

export const compact = (n) =>
  new Intl.NumberFormat("en", { notation: "compact", maximumFractionDigits: 1 }).format(n || 0);

export const timeAgo = (iso) => {
  const s = Math.max(1, Math.floor((Date.now() - new Date(iso).getTime()) / 1000));
  const units = [["y", 31536000], ["mo", 2592000], ["d", 86400], ["h", 3600], ["m", 60]];
  for (const [u, v] of units) if (s >= v) return `${Math.floor(s / v)}${u} ago`;
  return "just now";
};

export const fetchFeed = () => axios.get(`${API}/instagram/feed`).then((r) => r.data);

export const trendingIds = (posts) =>
  new Set([...posts].filter((p) => p.likes > 0).sort((a, b) => b.likes - a.likes).slice(0, 3).map((p) => p.id));
